import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/inquiries"



export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};


export const Details = async (values) => {
  return await axiosInstance(options).post(`${path}/details`, values);  
};

export const resolveInquiry = async (values) => {
  return await axiosInstance(options).post(`${path}/mark-resolve`, values);  
};

export const Delete = async (values) => {
  return await axiosInstance(options).post(`${path}/delete`, values);  
};

export const Reply = async (values) => {
  return await axiosInstance(options).post(`${path}/reply`, values);
};







